import { render, staticRenderFns } from "./PagamentoHistorico.vue?vue&type=template&id=75c1fcfb&"
import script from "./PagamentoHistorico.vue?vue&type=script&lang=js&"
export * from "./PagamentoHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports